module.exports = __webpack_public_path__ + "img/badge.834c6276.png";